import React, { Component } from "react";
import PropTypes from "prop-types";
import Chrome from "@zendesk/knowledge-chrome/lib/Chrome";
import t from "@zendesk/client-i18n-tools";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import gql from "graphql-tag";
import { showIndex } from "utils/navigation";
import LoadingOverlay from "components/LoadingOverlay";
import ErrorBoundary from "components/ErrorBoundary";
import { Query } from "react-apollo";
import createFilter from "state/createFilter";
import EditForm from "components/EditForm";
import ArticleMatches from "components/ArticleMatches";
import idFilters from "state/idFilters";
import yesNoFilters from "state/yesNoFilters";
import getFilterType from "utils/getFilterType";
import LoaderPanel from "components/LoaderPanel";
import styles from "./styles.css";

const verificationRuleQuery = gql`
  query VerificationRule($id: ID!) {
    verificationRule: node(id: $id) {
      ... on VerificationRule {
        id
        name
        filter {
          ... on VerificationRuleAuthorFilterTerm {
            author {
              id
            }
          }
          ... on VerificationRuleBrandFilterTerm {
            brand {
              id
            }
          }
          ... on VerificationRuleLabelFilterTerm {
            label {
              id
            }
          }
          ... on VerificationRulePermissionGroupFilterTerm {
            permissionGroup {
              id
            }
          }
          ... on VerificationRuleUserSegmentFilterTerm {
            userSegment {
              id
            }
          }
          ... on VerificationRuleCategoryFilterTerm {
            category {
              id
            }
          }
          ... on VerificationRuleSectionFilterTerm {
            section {
              id
            }
          }
          ... on VerificationRuleIsOpenForCommentFilterTerm {
            isOpenForComment
          }
          ... on VerificationRuleIsPromotedFilterTerm {
            isPromoted
          }
          ... on VerificationRuleOriginFilterTerm {
            origin
          }
          ... on VerificationRuleCreatedFilterTerm {
            created
          }
          ... on VerificationRuleUpdatedFilterTerm {
            updated
          }
        }
        frequency
        notification {
          recipient
        }
      }
    }
  }
`;

export default class EditRoute extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    isDuplicate: PropTypes.bool,
  };

  showIndex = e => {
    e.preventDefault();
    showIndex();
  };

  render() {
    const { id, isDuplicate } = this.props;

    return (
      <Chrome
        brandId={getCurrentBrandId()}
        dir={t.dir}
        topNav={
          <Chrome.Breadcrumbs>
            <Chrome.Breadcrumbs.Item key="settings">
              <a href="/hc/admin/general_settings">
                {t("knowledge-verification.settings")}
              </a>
            </Chrome.Breadcrumbs.Item>
            <Chrome.Breadcrumbs.Separator />
            <Chrome.Breadcrumbs.Item key="verification">
              <a href="/knowledge/verification/" onClick={this.showIndex}>
                {t("knowledge-verification.articleVerifications")}
              </a>
            </Chrome.Breadcrumbs.Item>
            <Chrome.Breadcrumbs.Separator />
            <Chrome.Breadcrumbs.Item key="editRule">
              {t("knowledge-verification.editRule")}
            </Chrome.Breadcrumbs.Item>
          </Chrome.Breadcrumbs>
        }
      >
        <ErrorBoundary>
          <Query query={verificationRuleQuery} variables={{ id }}>
            {({ data, loading, error, client }) => {
              if (error) {
                throw error;
              }

              if (loading) {
                return <LoaderPanel testId="loader" />;
              }

              if (!data.verificationRule) {
                return showIndex();
              }

              const {
                name,
                notification: { recipient },
                frequency,
                filter,
              } = data.verificationRule;

              const initialEditState = {
                ruleName: isDuplicate
                  ? t("knowledge-verification.duplicateTitle", {
                      name,
                    })
                  : name,
                frequency,
                notificationRecipient: recipient,
                filters: filter
                  .map(filterTerm => {
                    const type = getFilterType(filterTerm);

                    if (idFilters.includes(type)) {
                      return createFilter({
                        type,
                        value: filterTerm[type].id,
                      });
                    }

                    if (
                      yesNoFilters.includes(type) ||
                      ["origin", "created", "updated"].includes(type)
                    ) {
                      return createFilter({
                        type,
                        value: filterTerm[type],
                      });
                    }

                    return false;
                  })
                  .filter(Boolean),
              };

              client.cache.writeData({
                data: {
                  initialEditState: {
                    __typename: "InitialState",
                    ...initialEditState,
                  },
                  dirtyState: {
                    __typename: "DirtyState",
                    ...initialEditState,
                  },
                },
              });

              return (
                <LoadingOverlay>
                  <div className={styles.container}>
                    <EditForm id={id} isDuplicate={isDuplicate} />
                    <ArticleMatches />
                  </div>
                </LoadingOverlay>
              );
            }}
          </Query>
        </ErrorBoundary>
      </Chrome>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditRoute/index.js